export default {
    update: function(el, binding, vnode) {
        // console.log('updated')
            if(binding.value.grade || binding.value.grade === 0) {
                //show all corrects
                let correctAnswers = [];
                binding.value.exerciseAnswers.options.map(option => correctAnswers.push(option.id))
                // if(correctAnswers.includes(binding.value.option.id)) {
                //     el.style.border = '2px solid #1b4d21'
                //     el.style.backgroundColor = '#ededed'
                // }
                if(binding.value.answer.includes(binding.value.option.id) && correctAnswers.includes(binding.value.option.id)){
                    el.style.border = '1px solid #92e670'
                    el.style.backgroundColor = '#ededed'
                    el.style.color = 'green'
                }
                else if(binding.value.answer.includes(binding.value.option.id) && !correctAnswers.includes(binding.value.option.id)){
                    el.style.border = '1px solid #f05959'
                    el.style.backgroundColor = '#ededed'
                    el.style.color = '#f05959'
                }
            }
    },
   
  };
  